/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import customNavigation from './demo-navigation.json';

export const applyE2EDemoFeatures = (obj) => {
  const navigation = obj.features?.navigation;
  if (navigation) {
    return {
      ...obj,
      features: {
        ...obj.features,
        navigation: customNavigation,
      },
    };
  }

  return obj;
};

export default { applyE2EDemoFeatures };
